<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("authorization") }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form>
                        <v-container grid-list-md pb-0>
                            <v-layout wrap>
                                <v-flex xs12 sm6 pb-0>
                                    <v-text-field
                                        :label="`${$t('eMail')} *`"
                                        :hint="$t('eMailAddress')"
                                        v-model="email"
                                        autofocus
                                        browser-autocomplete="username"
                                        required
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 pb-0>
                                    <v-text-field
                                        :label="`${$t('password')} *`"
                                        v-on:keyup.enter="doLogin"
                                        type="password"
                                        v-model="password"
                                        browser-autocomplete="current-password"
                                        required
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 pt-0 pl-1 style="max-height: 45px;">
                                    <v-checkbox
                                        v-model="rememberMe"
                                        :label= "`${$t('rememberMe')}`"
                                        hide-details
                                    ></v-checkbox>
                                </v-flex>

                                <v-flex xs12>
                                    <a href="#" @click="showPasswpordReset">{{ $t("forgotPassword") }}</a>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                    <v-container grid-list-md pl-3>
                        <v-layout wrap>
                            <small>{{ $t("reCaptchaNoteP1") }}&nbsp;
                                <a href="https://policies.google.com/privacy" target="_blank">{{ $t("privacyPolicy")}}</a> {{ $t("and") }}&nbsp;
                                <a href="https://policies.google.com/terms" target="_blank">{{ $t("termsOfService") }}</a>{{ $t("reCaptchaNoteP2") }}.
                            </small>
                        </v-layout>
                    </v-container>
                    <v-divider class="mt-2"/>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="doLogin">{{ $t("authorization") }}</v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
        <password-reset-dialog ref="PasswordReset"/>
    </v-layout>
</template>

<script>
    import MessageBox          from "./MessageBox";
    import PasswordResetDialog from "./PasswordResetDialog";

    export default {
        name: "AuthDialog",

        components: {
            MessageBox,
            PasswordResetDialog
        },

        data () {
            return {
                dialog:         false,
                loggedIn:       false,
                email:          "",
                password:       "",
                recaptchaToken: "",
                rememberMe:     false
            }
        },

        watch: {
            rememberMe: function (val) {
                localStorage.rememberMe = val;
                if (!val) {
                    localStorage.rememberedUserEMail = "";
                }
            }
        },

        async mounted () {
            // TODO recapctha, на данный момент не работает
            //await this.$recaptchaLoaded();
            //const token     = await this.$recaptcha("login");
            //const recaptcha = this.$recaptchaInstance;
            //recaptcha.hideBadge();

            this.rememberMe = localStorage.rememberMe ? JSON.parse(localStorage.rememberMe) : false;

            if (this.rememberMe) {
                this.email = localStorage.rememberedUserEMail;
            }
        },

        methods: {
            /**
             *  Выполнение процедуры авторизации
             */
            async doLogin () {
                //this.recaptchaToken = await this.$recaptcha("login");

                await this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}login/`,
                    data: {
                        email:    this.email,
                        password: this.password,
                        //token:    this.recaptchaToken
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                        this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                    } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                        this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                    } else if (response.data.status == "failure") {
                        this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                    }
                    this.loggedIn = response.data.loggedIn;

                    if (this.rememberMe) {
                        localStorage.rememberedUserEMail = this.email;
                    }
                    else {
                        this.email = "";
                        localStorage.rememberedUserEMail = "";
                    }
                }).catch(error => {
                    this.$debug.error(error);

                    if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                    }
                });

                this.dialog   = !this.loggedIn;
                this.password = "";
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             *  Отображает диалог сброса пароля
             */
            showPasswpordReset () {
                this.$refs.PasswordReset.title  = this.$t("passwordReset");
                this.$refs.PasswordReset.dialog = true;
            }
        }
    }
</script>
